export const UPDATE_EVENT = 'UPDATE_EVENT'



// WEBPACK FOOTER //
// ./src/store/eventList/mutation-types.js